const Meta = ({ title, description, keyword }) => {
    return (
        <div>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keyword" content={keyword} />
        </div>
    )
}

Meta.defaultProos = {
    title: 'Vivek padelkar| Full stack developer',
    description: 'I am full stack developer Expereince in React,Node,MongoDB',
    keyword: 'vivek padelkar,padelkar,vivek,full stack developer portfolio,web developer portfolio,developer portfolio,portfolio,frontend developer portfolio,react developer portfolio'
}
export default Meta